/* eslint-disable node/no-callback-literal */
// 腾讯云COS上传工具，官方推荐写法，支持自动重试、进度回调、断网重连
import COS from 'cos-js-sdk-v5'
import request from '@/utils/request'

// 获取临时密钥API
async function getCosTempKeys () {
  const res = await request.get('/cos/cos-signature')
  if (res && res.code === 200) {
    return res.data
  } else {
    throw new Error('获取COS临时密钥失败')
  }
}

// 上传主函数（官方推荐：每次上传前都用最新临时密钥初始化COS实例）
export async function uploadToCos ({
  file,
  onProgress,
  maxRetry = 3
}) {
  let retryCount = 0
  let lastError = null
  let tempKeys = null
  let cos = null

  async function initCos () {
    tempKeys = await getCosTempKeys()
    cos = new COS({
      SecretId: tempKeys.tmpSecretId,
      SecretKey: tempKeys.tmpSecretKey,
      SecurityToken: tempKeys.sessionToken,
      StartTime: tempKeys.startTime, // 建议传服务端时间，避免本地时间不准
      ExpiredTime: tempKeys.expiredTime
    })
  }

  async function doUpload () {
    if (!cos) await initCos()
    const key = genCosObjectKey(file)
    return new Promise((resolve, reject) => {
      const callback = function (err, data) {
        if (err == null) {
          let url = ''
          if (data.Key) {
            url = `https://${tempKeys.bucket}.cos.${tempKeys.region}.myqcloud.com/${data.Key}`
          } else if (data.Location) {
            url = data.Location.startsWith('http') ? data.Location : `https://${data.Location}`
          } else {
            return reject(new Error('上传成功但返回数据缺少文件地址'))
          }
          resolve(url)
        } else {
          reject(err)
        }
      }
      // 根据文件大小选择上传方式
      if (file.size > 20 * 1024 * 1024) {
        // 大于20MB用分片上传
        cos.sliceUploadFile({
          Bucket: tempKeys.bucket,
          Region: tempKeys.region,
          Key: key,
          Body: file,
          SliceSize: 1024 * 1024 * 5, // 5MB分片
          onProgress: function (progressData) {
            if (onProgress) onProgress(progressData)
          }
        }, callback)
      } else {
        // 小文件用putObject
        cos.putObject({
          Bucket: tempKeys.bucket,
          Region: tempKeys.region,
          Key: key,
          Body: file,
          onProgress: function (progressData) {
            if (onProgress) onProgress(progressData)
          }
        }, callback)
      }
    })
  }

  while (retryCount < maxRetry) {
    try {
      if (!navigator.onLine) {
        await waitForReconnect()
      }
      return await doUpload()
    } catch (e) {
      lastError = e
      retryCount++
      if (!navigator.onLine) {
        await waitForReconnect()
      } else if (retryCount < maxRetry) {
        await sleep(1000 * retryCount)
      }
    }
  }
  throw lastError
}

function genCosObjectKey (file) {
  // 兼容file.name缺失和无扩展名，优先用file.type判断
  let ext = 'bin'
  if (file.name && file.name.includes('.')) {
    ext = file.name.split('.').pop()
  } else if (file.type) {
    if (file.type.startsWith('image/')) {
      ext = file.type.split('/').pop()
    } else if (file.type.startsWith('video/')) {
      ext = file.type.split('/').pop()
    }
  }
  const ts = Date.now()
  const date = new Date(ts)
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  // 生成类似 uploads/2025-07-03/1751549224643_xxxxx.jpg
  return `uploads/${yyyy}-${mm}-${dd}/${ts}_${Math.random().toString(36).slice(2, 8)}.${ext}`
}

function waitForReconnect () {
  return new Promise(resolve => {
    if (navigator.onLine) return resolve()
    const handler = () => {
      if (navigator.onLine) {
        window.removeEventListener('online', handler)
        resolve()
      }
    }
    window.addEventListener('online', handler)
  })
}

function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
